import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioHierarquiaAssuntoReducer(state = initialState.relatorioHierarquiaAssunto, action){
    switch(action.type) {
        case types.RELAT_HIERARQUIA_ASSUNTO:
            
            return action.relatorioHierarquiaAssunto;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioHierarquiaAssuntoReducer.js
 **/